// @flow

import React, { Fragment } from "react";
import { BaseHierarchyTree, Icons } from "../index";
import type { TreeBranch } from "../base-hierarchy-tree";
import { TYPE_ORGANIZATION } from "../base-hierarchy-tree/util";
import withSearchable from "../searchable-hierarchy-tree";
import DropDownItem from "../dropdown/dropdown-item";
import "./organization.style.scss";

type Props = $Exact<{
  tree: TreeBranch,
  disabled: boolean,
  expanded: number[],
  excluded?: number[],
  expandAll: boolean,
  hoverEmployee: boolean,
  selectedBranchId?: number | null,
  onAction: (action: string, branch: TreeBranch) => void,
  onDrop: (from: number, to: number) => void,
  onClick?: (branch: TreeBranch) => void,
  hideEmployee: boolean,
  showDisabled: boolean,
}>;

export class OrganizationHierarchyTree extends React.Component<Props> {
  static defaultProps = {
    disabled: false,
    expanded: [],
    excluded: [],
    selectedBranchId: null,
    onClick: () => undefined,
  };

  getEmployeesCount = (branch: TreeBranch) => {
    //    $FlowFixMe - Missing type annotation for `T`. `T` is a type parameter declared in array type [1] and was implicitly instantiated at call of method `filter` [2]
    const employees = (branch.children || []).filter((child: TreeBranch) => child.data.employeeId);
    const inactiveEmployees = employees.filter(employee => employee.data.isActive === false);
    return {
      total: employees,
      inactive: inactiveEmployees,
    };
  };
  get expandedNodes() {
    return this.props.expanded;
  }

  triggerAction = (action: string, branch: TreeBranch) => () => {
    this.props.onAction(action, branch);
  };

  actions = (branch: TreeBranch) => {
    const employeesCount = this.getEmployeesCount(branch);
    if (this.props.disabled) {
      return <div />;
    }
    if (this.props.tree.data.id === branch.data.id || branch.data.reference === "UNASSIGNED") {
      return (
        <DropDownItem onClick={this.triggerAction("add", branch)}>
          <Icons.PlusIcon className="mr-2 tree-icon" color="teal" /> {"Add Sub-department"}
        </DropDownItem>
      );
    }
    return (
      <Fragment>
        <DropDownItem onClick={this.triggerAction("add", branch)}>
          <Icons.PlusIcon className="mr-2 tree-icon" /> {"Add Sub-department"}
        </DropDownItem>

        <DropDownItem onClick={this.triggerAction("move", branch)}>
          <Icons.SquareArrowIcon className="mr-2 tree-icon" /> {"Move This Department"}
        </DropDownItem>

        <DropDownItem onClick={this.triggerAction("rename", branch)}>
          <Icons.PencilIcon className="mr-2 tree-icon" /> {"Edit This Department"}
        </DropDownItem>

        {employeesCount.total.length < 1 ? (
          <DropDownItem color="negative" onClick={this.triggerAction("delete", branch)}>
            <Icons.TrashIcon className="mr-2 tree-icon" color="negative" />{" "}
            {"Delete This Department"}
          </DropDownItem>
        ) : (
          <DropDownItem className={"text-disabled-light"} color="text-disabled-light">
            <Icons.TrashIcon className="mr-2 tree-icon" color="disabled" />
            {"Delete This Department"}
          </DropDownItem>
        )}
      </Fragment>
    );
  };

  renderControl = (branch: TreeBranch, isHovered: boolean, isInactive: boolean) => {
    if (branch.data.type === TYPE_ORGANIZATION) {
      return !isHovered ? (
        <Icons.ThreePersons2Icon className="tree-icon" color="orange" />
      ) : (
        <Icons.MoveDraggerIcon className="tree-icon" color="orange" />
      );
    }

    return <Icons.PersonIcon className="tree-icon" color={isInactive ? "negative" : "coffee-d3"} />;
  };

  render() {
    return (
      <BaseHierarchyTree
        className="organizations-tree"
        tree={this.props.tree}
        draggable={!this.props.disabled}
        actions={this.actions}
        onDrop={this.props.onDrop}
        disabled={false}
        expanded={this.expandedNodes}
        expandAll={this.props.expandAll}
        hoverEmployee={this.props.hoverEmployee}
        excluded={this.props.excluded}
        hasControl={true}
        selectedBranchId={this.props.selectedBranchId}
        onClick={this.props.onClick}
        renderControl={this.renderControl}
        hideEmployee={this.props.hideEmployee}
        showDisabled={this.props.showDisabled}
      />
    );
  }
}

// $FlowFixMe Related to TAN-10565
export default withSearchable(OrganizationHierarchyTree);
